import {RenameInterface} from "@/views/Admin/Events/Event/Promocodes/Rename/Rename.interface";

export const RenameSchema: RenameInterface = {
    isLoading: false,
    fields: {
        name: {
            label: 'Группа',
            placeholder: 'Введите название группы',
            value: null,
            error: null,
            isDisabled: false,
            isRequired: false,
            isLoading: false,
        },
    }
}
